import type {GuidedMiddleware} from '../models/middleware';
import type {GuidedApiCallParams, GuidedItemsV2} from '../models/models';
import {makeLogger} from '../../../logger/logger';

const {
  info,
  // debug,
  // warn,
  // err
} = makeLogger({
  pathToCurrentFile: 'components/guided2/middlewares/termForceWildcardOnEmpty.ts',
});


export const termForceWildcardOnEmpty: GuidedMiddleware = async (params: GuidedApiCallParams, next): Promise<GuidedItemsV2> => {

    // info('Enter termForceWildcardOnEmpty middleware', {params});

    if (params.guidedRequest.searchTerm == '') {
      /*
      info('Fixing the term', {
        was: params.guidedRequest.searchTerm,
        willBe: '*'
      });
      //*/
      params.guidedRequest.searchTerm = '*';
    }

    // info('nesting and returning', {params});
    return await next(params);
};
